<template>
    <div class="sign-in-document-container">
      <h5 class="title-text mb-3">
        {{
          isOptional
            ? `${
                vaccineComplianceName.charAt(0).toUpperCase() +
                vaccineComplianceName.slice(1)
              } ${$t('common.optionalWithBrackets')}`
            : vaccineComplianceName.charAt(0).toUpperCase() +
              vaccineComplianceName.slice(1)
        }}
      </h5>

      <div class="user-infocontainer">
        <p
          class="user-info"
          v-if="vaccine_pcr.pivot && vaccine_pcr.pivot.updated_at"
        >
          {{ getDate(vaccine_pcr.pivot.updated_at) }}<b> . </b> By
          {{
            vaccine_pcr.pivot.metadata
              ? vaccine_pcr.pivot.metadata.actionBy
              : "User"
          }}<strong class="strong-txt">
            ({{
              vaccine_pcr.pivot.full_name_action_by
                ? vaccine_pcr.pivot.full_name_action_by
                : "-"
            }})</strong
          >
        </p>
      </div>
      <!-- document  -->
      <div
        v-if="!default_walk_in"
        class="mb-3 d-flex align-items-center document-style"
      >
        <vp-multiselect
          v-if="!vaccine_pcr.document"
          id="document"
          v-model="vaccine_pcr.document"
          :options="vaccine_pcr.documentOptions"
          :placeholder="$t('signInOut.selectDocument')"
          :show-labels="false"
          label="value"
          :allowEmpty="true"
          :taggable="true"
          deselectLabel
          @select="updateDocumentDetails()"
        />

        <div class="alloverlay-layers" v-if="vaccine_pcr.document">
          <div class="closing-overlay" v-if="vaccine_pcr.document">
            <h4 class="overlay-con">{{ vaccine_pcr.document.value }}</h4>
            <span
              class="overlay-closing"
              @click="
                clearDocument();
                requiredModelsHandler();
              "
            >
            {{$t('common.remove')}}
            </span>
          </div>
          <!-- <div class="note-sep-line"></div> -->
          <ShowDocumentDetails
            :document_file_src="documentFile.img"
            :documentDetails="documentDetails"
          />
        </div>

      </div>
      <template v-if="!vaccine_pcr.document">
        <div class="info-wrapper text-center">
          <p class="add-docs-msg">
            <template v-if="!default_walk_in" class="text-muted mb-1"
              >{{$t('common.or')}}</template
            >
            {{$t('signInOut.addDocManually')}}
          </p>
        </div>
        <!-- vaccine-pcr toggle -->
        <b-form-radio-group
          :class="vaccine_pcr.document && 'disabled-item'"
          class="checkbox-wrapper"
          v-model="vaccine_pcr.vaccine_pcr"
          @change="requiredModelsHandler()"
        >
          <div
            v-if="isPcrEnabled"
            class="d-flex align-items-center align-content-center vaccine-pcrradio"
          >
            <b-form-radio value="vaccine">{{$t('common.doc.vaccine')}}</b-form-radio>
            <b-form-radio class="pcr-radio" value="pcr">{{$t('common.doc.PCR')}}</b-form-radio>
          </div>
        </b-form-radio-group>

        <!-- vaccine data -->
        <div
          v-if="vaccine_pcr.vaccine_pcr == 'vaccine'"
          class="vaccine-inputs-wrapper"
        >
          <!-- name   -->
          <b-form-group :class="vaccine_pcr.document && 'disabled-item'">
            <vp-multiselect
              id="protocols"
              :title="$t('signInOut.vaccineProtocol')"
              v-model="vaccine_pcr.vaccine_protocol"
              class="vp-mb-16"
              :options="protocolOptions"
              :placeholder="$t('signInOut.vaccineProtocol')"
              :show-labels="false"
              :allowEmpty="true"
              @input="updateProtocolModel(), requiredModelsHandler()"
            />
            <vp-input
              id="name"
              v-model="vaccine_pcr.vaccine_name"
              type="text"
              class="input-style"
              :placeholder="$t('signInOut.vaccineName')"
              :label="$t('signInOut.vaccineName')"
              width="416"
              :class="{
                'is-invalid':
                  submitted &&
                  validation.vaccine_pcr.vaccine_name.$error &&
                  !isLoading,
                'cursor-stop':
                  vaccine_pcr.vaccine_name &&
                  vaccine_pcr.vaccine_name.length >= 30,
              }"
              maxlength="30"
              @input="requiredModelsHandler()"
            ></vp-input>
            <div
              v-if="
                submitted &&
                !validation.vaccine_pcr.vaccine_name.required &&
                !isLoading
              "
              class="invalid-feedback"
            >
              Vaccine name is required.
            </div>
          </b-form-group>
          <!-- number   -->
          <b-form-group :class="vaccine_pcr.document && 'disabled-item'">
            <vp-input
              :disabled="
                vaccine_pcr.document &&
                Object.keys(vaccine_pcr.document).length > 0
              "
              id="number"
              v-model="vaccine_pcr.vaccine_number"
              width="416"
              type="text"
              class="input-style"
              :placeholder="$t('signInOut.batchNumber')"
              :label="$t('signInOut.batchNumber')"
            ></vp-input>
          </b-form-group>

          <div class="d-flex justify-content-between vp-width-416">
            <!-- given date  -->
            <b-form-group :class="vaccine_pcr.document && 'disabled-item'">
              <VpDatepicker
                :class="{
                  'is-invalid invalid-date-input':
                    submitted &&
                    validation.vaccine_pcr.vaccine_expire_date.$error &&
                    !isLoading,
                }"
                width="200"
                v-model="vaccine_pcr.vaccine_given_date"
                :first-day-of-week="1"
                lang="en"
                :placeholder="$t('common.doc.dateTaken')"
                value-type="format"
                format="YYYY-MM-DD"
                :disabledDate="disableDateAfterCurrent"
                :disabled="
                  vaccine_pcr.document &&
                  Object.keys(vaccine_pcr.document).length > 0
                "
                @input="requiredModelsHandler()"
              />
              <div
                v-if="
                  submitted &&
                  !validation.vaccine_pcr.vaccine_given_date.required &&
                  !isLoading
                "
                class="invalid-feedback"
              >
                Vaccine given date is required.
              </div>
            </b-form-group>
            <!-- expire date  -->
            <b-form-group :class="vaccine_pcr.document && 'disabled-item'">
              <VpDatepicker
                :class="{
                  'is-invalid invalid-date-input':
                    submitted &&
                    validation.vaccine_pcr.vaccine_expire_date.$error &&
                    !isLoading,
                }"
                v-model="vaccine_pcr.vaccine_expire_date"
                :first-day-of-week="1"
                lang="en"
                :placeholder="$t('signInOut.expiryDate')"
                value-type="format"
                format="YYYY-MM-DD"
                :disabledDate="disabledExpiredDate"
                width="200"
                :disabled="!vaccine_pcr.vaccine_given_date"
                @input="requiredModelsHandler()"
              />
              <div
                v-if="
                  submitted &&
                  !validation.vaccine_pcr.vaccine_expire_date.required &&
                  !isLoading
                "
                class="invalid-feedback"
              >
                Vaccine expire date is required.
              </div>
            </b-form-group>
          </div>

          <!-- vaccine file upload -->
          <div class="mb-3">
            <div>
              <button
                type="button"
                @click="pickImage"
                class="upload-btn"
                :class="{
                  'file-validation': documentFileErr && !documentFile.img,
                }"
              >
                <b-form-file
                  accept="image/*"
                  id="imagePicker"
                  @change="onFileChange"
                  class="d-none upload-btn"
                  v-model="vaccine_pcr.vaccine_document"
                  @input="requiredModelsHandler()"
                ></b-form-file>
                <div class="d-flex justify-content-between align-items-baseline">
                  <p
                    class="mt-3 file-label"
                    :class="{
                      'file-label-img-selected': documentFile.img,
                    }"
                  >
                    {{ $t('signInOut.vaccineFile') }}
                  </p>
                  <span class="mt-2 paperclip-icon" v-if="!documentFile.img"
                    ><i class="mdi mdi-paperclip mdi-24px"></i
                  ></span>
                </div>
              </button>
              <div v-if="documentFile.img" style="position: relative">
                <img
                  :class="{
                    'img-bg': !documentFile.img,
                    'img-file': documentFile.img,
                  }"
                  :src="documentFile.img"
                />
                <i
                  @click="removeImage()"
                  class="mdi mdi-delete mdi-24px remove-file-icon text-center"
                >
                </i>
              </div>

              <div
                class="file-note-text mt-1"
                v-if="!documentFileErr && !documentFile.img"
              >
                <b>{{$t('common.notes.note')}}: </b>{{ $t('common.notes.uploadImgNoteDoc') }}
              </div>
              <p class="file-err-text mt-1" v-if="documentFileErr">
                {{ $t('common.notes.uploadImgNoteDoc') }}
              </p>
            </div>
          </div>
        </div>
        <!-- pcr data  -->
        <div
          v-if="vaccine_pcr.vaccine_pcr == 'pcr'"
          class="pcr-inputs-wrapper mt-4"
        >
          <vp-multiselect
            class="mb-3"
            v-model="vaccine_pcr.pcr_result"
            :placeholder="$t('signInOut.pcrResult')"
            temperature-label
            id="pcr"
            :options="pcrOptions"
            :show-labels="false"
            label="label"
            track-by="value"
            :allowEmpty="true"
            @input="requiredModelsHandler()"
            zIndex="10"
          />

          <div class="d-flex justify-content-between">
            <b-form-group>
              <vp-datepicker
                width="200"
                v-model="vaccine_pcr.pcr_date"
                :class="{
                  'is-invalid invalid-date-input':
                    submitted &&
                    validation.vaccine_pcr.pcr_date.$error &&
                    !isLoading,
                }"
                :first-day-of-week="1"
                lang="en"
                :placeholder="$t('common.doc.dateTaken')"
                value-type="format"
                format="YYYY-MM-DD"
                :disabledDate="disableDateAfterCurrent"
                @input="requiredModelsHandler()"
              >
                <i slot="icon-calendar">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666656 14.8332C0.666656 16.2498 1.74999 17.3332 3.16666 17.3332H14.8333C16.25 17.3332 17.3333 16.2498 17.3333 14.8332V8.1665H0.666656V14.8332ZM14.8333 2.33317H13.1667V1.49984C13.1667 0.999837 12.8333 0.666504 12.3333 0.666504C11.8333 0.666504 11.5 0.999837 11.5 1.49984V2.33317H6.49999V1.49984C6.49999 0.999837 6.16666 0.666504 5.66666 0.666504C5.16666 0.666504 4.83332 0.999837 4.83332 1.49984V2.33317H3.16666C1.74999 2.33317 0.666656 3.4165 0.666656 4.83317V6.49984H17.3333V4.83317C17.3333 3.4165 16.25 2.33317 14.8333 2.33317Z"
                      :fill="
                        vaccine_pcr.vaccine_given_date ? '#103F5E' : '#787878'
                      "
                    />
                  </svg>
                </i>
                <div
                  v-if="
                    submitted &&
                    !validation.vaccine_pcr.pcr_date.required &&
                    !isLoading
                  "
                  class="invalid-feedback"
                >
                  PCR date is required.
                </div>
              </vp-datepicker>
            </b-form-group>

            <!-- PCR File (upload) -->
            <div class="mb-3">
              <button
                type="button"
                @click="pickImage"
                class="upload-btn"
                :class="{
                  'file-validation': pcrFileErr && !pcrFile.img,
                }"
              >
                <b-form-file
                  accept="image/*"
                  id="imagePicker"
                  @change="onFileChange"
                  v-model="vaccine_pcr.pcr_document"
                  class="d-none upload-btn"
                  @input="requiredModelsHandler()"
                ></b-form-file>
                <div class="d-flex justify-content-between align-items-baseline">
                  <p
                    class="mt-3 file-label"
                    :class="{
                      'file-label-img-selected': pcrFile.img,
                    }"
                  >
                    {{$t('signInOut.pcrFile')}}
                  </p>
                  <span class="mt-2 paperclip-icon" v-if="!pcrFile.img"
                    ><i class="mdi mdi-paperclip mdi-24px"></i
                  ></span>
                </div>
              </button>
              <div v-if="pcrFile.img" style="position: relative">
                <img
                  :class="{
                    'img-bg': !vaccine_pcr.pcr_document,
                    'img-file': vaccine_pcr.pcr_document,
                  }"
                  :src="pcrFile.img"
                />
                <i
                  @click="removePcrImage()"
                  class="mdi mdi-delete mdi-24px remove-file-icon"
                >
                </i>
              </div>

              <div
                class="file-note-text mt-1"
                v-if="!pcrFileErr && !pcrFile.img"
              >
                <b>{{$t('common.notes.note')}}: </b> {{ $t('common.notes.uploadImgNoteDoc') }}
              </div>
              <p class="file-err-text mt-1" v-if="pcrFileErr">
                {{ $t('common.notes.uploadImgNoteDoc') }}
              </p>
            </div>
          </div>
        </div>
        <!-- notes  -->
        <b-form-group
          :class="
            vaccine_pcr.document &&
            Object.keys(vaccine_pcr.document).length > 0 &&
            'disabled-item'
          "
        >
          <vp-textarea
            width="416"
            class="input-style mb-2"
            id="notes"
            v-model="vaccine_pcr.notes"
            type="text"
            :label="$t('signInOut.documentNotes')"
            rows="3"
            no-resize
          ></vp-textarea>
        </b-form-group>
      </template>
      <div class="document-line-inside"></div>

    </div>
</template>

<script>
import moment from "moment";

import ShowDocumentDetails from "../../reports/showDocumentDetails/showDocumentDetails.vue";

export default {
  components: { ShowDocumentDetails },
  props: [
    "vaccineComplianceName",
    "vaccine_pcr",
    "submitted",
    "validation",
    "default_walk_in",
    "isOptional",
    "isPcrEnabled",
    "isLoading",
  ],
  data() {
    return {
      pcrOptions: [
        { label: "Negative", value: false },
        { label: "Positive", value: true },
      ],
      protocolOptions: [
        "EU Digital COVID Certificate",
        "NHS (Domestic/International)",
        "Smart Health Card (SHC)",
        "NYS Excelsior Pass & NYS Excelsior Pass Plus",
      ],
      pcrResult: false,
      pcrFileErr: false,
      documentFileErr: false,
      isDocumentFileRemoved: false,
      documentFile: {
        img: "",
      },
      pcrFile: {
        img: "",
      },
      pcrFileImageChanged: null,
      pcrFileImage: null,
      isPcrFileRemoved: false,
      documentDetails: {},
    };
  },
  destroyed() {
    this.vaccine_pcr.document = "";
  },
  watch: {
    "vaccine_pcr.vaccine_given_date"(val) {
      if (!val) this.vaccine_pcr.vaccine_expire_date = null;
    },
  },
  methods: {
    updateDocumentDetails(document) {
      this.vaccine_pcr.vaccine_protocol = "";
      this.vaccine_pcr.vaccine_name = "";
      this.vaccine_pcr.vaccine_number = "";
      this.vaccine_pcr.vaccine_given_date = "";
      this.vaccine_pcr.vaccine_expire_date = "";
      this.vaccine_pcr.vaccine_document = "";
      this.vaccine_pcr.pcr_result = "";
      this.vaccine_pcr.pcr_date = "";
      this.vaccine_pcr.pcr_document = "";

      this.requiredModelsHandler();

      const certificateModel = document?.metadata?.certificateModel;
      if (document?.type == "covid_vaccine") {
        this.documentDetails = {
          "Vaccine Protocol":
            document?.metadata?.protocol != "manual"
              ? document?.metadata?.protocol
              : null,
          "Vaccine Name": certificateModel?.vaccinations[0]?.vaccine,
          "Batch Number": certificateModel?.vaccinations[0]?.batchNumber,
          "Date Taken": certificateModel?.vaccinations[0]?.dateOfVaccination
            ? moment(
                certificateModel.vaccinations[0].dateOfVaccination,
                "YYYY-MM-DD"
              ).format("DD/MM/YYYY")
            : null,
          "Expiry Date": document.expiry_date,
          "Vaccine File": document.metadata.fileAttach,
        };
      } else if (document?.type == "covid_pcr") {
        console.log(document);
        this.documentDetails = {
          "PCR Result": document.name,
          "Date Taken": certificateModel.tests[0]?.dateTimeOfTestResult
            ? moment(
                certificateModel.tests[0].dateTimeOfTestResult,
                "YYYY-MM-DD hh:mm:ss"
              ).format("DD/MM/YYYY")
            : null,
          "Vaccine File": document.metadata.fileAttach,
        };
      }
    },
    requiredModelsHandler() {
      if (this.isOptional) {
        //If a field is filled up ,the rest of the fields must be submitted
        if (
          this.vaccine_pcr.vaccine_pcr == "vaccine" &&
          (this.vaccine_pcr.vaccine_name ||
            this.vaccine_pcr.vaccine_given_date ||
            this.vaccine_pcr.vaccine_expire_date ||
            this.vaccine_pcr.vaccine_document ||
            this.vaccine_pcr.vaccine_protocol)
        ) {
          this.$emit("updateIsOptional", false);
        } else if (
          this.vaccine_pcr.vaccine_pcr == "pcr" &&
          (this.vaccine_pcr.pcr_date ||
            this.vaccine_pcr.pcr_document ||
            this.vaccine_pcr.pcr_result)
        ) {
          this.$emit("updateIsOptional", false);
        } else {
          this.$emit("updateIsOptional", true);
        }
      }
    },
    getDate(date) {
      return moment
        .utc(date)
        .tz(moment.tz.guess())
        .format("DD/MM/YYYY - h:mm A");
    },
    disabledExpiredDate(date) {
      const givenDate = new Date();
      givenDate.setHours(0, 0, 0, 0);
      return date <= givenDate;
    },
    disableDateAfterCurrent(date) {
      return date > new Date();
    },
    clearDocument() {
      this.vaccine_pcr.document = null;
    },
    updateProtocolModel() {
      this.$emit("vaccineProtocolChange", this.vaccine_pcr.vaccine_protocol);
    },
    pickImage() {
      document.getElementById("imagePicker").click();
    },
    onFileChange(e) {
      //Vaccine file
      if (this.vaccine_pcr.vaccine_pcr == "vaccine") {
        this.documentFileErr = false;

        let file = e.target.files[0];
        if (!file || file.type.indexOf("image/") !== 0) return;

        const extensionType = file.type.split("/")[1];
        if (extensionType != "png" && extensionType != "jpeg") {
          return (this.documentFileErr = true);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let newImg = new Image();
          newImg.onload = () => {
            if (file.size > 3097152) {
              return (this.documentFileErr = true);
            }
            this.documentFile.img = URL.createObjectURL(file);
            this.isDocumentFileRemoved = false;
          };
          newImg.src = evt.target.result;
          // this.vaccineUploadedImg = file;
          this.vaccine_pcr.vaccine_document = file;
        };
        reader.onerror = (evt) => {
          console.error(evt);
        };
      } else {
        //PCR File
        this.pcrFileErr = false;

        let file = e.target.files[0];
        if (!file || file.type.indexOf("image/") !== 0) return;

        const extensionType = file.type.split("/")[1];
        if (extensionType != "png" && extensionType != "jpeg") {
          return (this.pcrFileErr = true);
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let newImg = new Image();
          newImg.onload = () => {
            if (file.size > 3097152) {
              return (this.pcrFileErr = true);
            }
            this.pcrFile.img = URL.createObjectURL(file);
            this.isPcrFileRemoved = false;
          };
          newImg.src = evt.target.result;
          // this.pcrUploadedImg = file;
          this.vaccine_pcr.pcr_document = file;
        };
        reader.onerror = (evt) => {
          console.error(evt);
        };
      }
    },
    removeImage() {
      this.documentFile.img = "";
      this.isDocumentFileRemoved = true;
      this.vaccine_pcr.vaccine_document = null;
    },
    removePcrImage() {
      this.pcrFile.img = "";
      this.isPcrFileRemoved = true;
      this.vaccine_pcr.pcr_document = null;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .document-line-inside{
    height: 1px;
    background: #000000;
    margin: 29px auto 19px;
    opacity: .08;
  }
  .pcr-inputs-wrapper {
    .mdi-24px.mdi:before {
      margin-inline-start: 14px;
      margin-top: 1px;
    }
    .mdi-paperclip {
      position: relative;
      inset-inline-end: 14px;
    }
  }

  .vaccine-inputs-wrapper {
    .mdi-paperclip {
      position: relative;
    }
  }
  .upload-btn {
    background-color: #f2f2f2;
    color: #000000;
    width: 200px;
    height: 55px;
    border-radius: 4px;
    border: 0;
  }
  .remove-file-icon {
    position: absolute;
    z-index: 5;
    width: 51px;
    height: 39px;
    border-radius: 5px;
    bottom: 6px;
    inset-inline-start: 143px;
    opacity: 0;
    color: #ffffff;
  }
  .remove-file-icon:hover {
    background-color: #666666;
    opacity: 0.8 !important;
    display: block;
  }
  .file-note-text {
    width: 200px;
    font-weight: 700;
    font-size: 12px !important;
    line-height: 17px;
    text-align: start;
    letter-spacing: 0.25px;
    max-width: 280px !important;
    color: #939393;
    opacity: 0.8;
  }

  .file-label {
    margin-inline-start: 15px;
    margin-bottom: 10px;
  }
  .file-label-img-selected {
    color: #3d637c;
    margin-bottom: 15px;
  }
  .img-bg {
    // position: absolute;
    z-index: 4;
    width: 50.5px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 7px;
    // inset-inline-start: 143px;
    border: 0px;
  }
  .img-file {
    position: absolute;
    z-index: 4;
    width: 51px;
    height: 38.4px;
    border-radius: 5px !important;
    bottom: 6px;
    inset-inline-start: 143px;
    border: 0px;
  }
}
.user-infocontainer {
  background: #f7f7f7;
  width: 411px;
  margin: 0px auto 26px auto;
  p.user-info {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #939393;

    padding-top: 5px;
    padding-bottom: 5px;
    padding-inline-start: 11px;
    margin: 0px !important;
  }
}
.closing-overlay {
  width: 415px;
  display: flex;
  height: 55px;
  align-items: center;
  background: #f2f2f2;
  justify-content: space-between;
  border-radius: 4px;
  h4.overlay-con {
    padding-inline-start: 20px;
    font-weight: 700;
    font-size: 16px;
    margin-top: 10px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #103f5e;
  }
  span.overlay-closing {
    padding-inline-end: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.25px;
    text-align: start;
    color: #f46a6a;
    cursor: pointer;
  }
}

.add-docs-msg {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-top: 35px;
  margin-bottom: 35px;

  color: #666666;

  mix-blend-mode: normal;
}
.title-text {
  color: #bebebe;
  font-weight: bold;
}
.disabled-item {
  opacity: 0.5;
  cursor: not-allowed;
}

.input-style {
  background-color: #f2f2f2;
  border-radius: 4px;
}
</style>
